import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { useDefaultComponentValue } from '../../utils';
import { useIsInToolMenu } from '../hooks';
const DIAMETER = 40;
const COMPONENT_NAME = 'AppbarButton';
const AppbarButton = /*#__PURE__*/ forwardRef((inProps, ref)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, size = 'medium', title, open, ...other } = props;
    const isInToolMenu = useIsInToolMenu(other);
    if (isInToolMenu) {
        return /*#__PURE__*/ React.createElement(MenuItem, other, /*#__PURE__*/ React.createElement(ListItemIcon, null, children), /*#__PURE__*/ React.createElement(ListItemText, null, title));
    }
    return /*#__PURE__*/ React.createElement(Tooltip, {
        title: title,
        placement: "bottom"
    }, /*#__PURE__*/ React.createElement(IconButton, {
        size: size,
        ref: ref,
        sx: [
            {
                '&:hover': {
                    backgroundColor: (theme)=>alpha(theme.palette.common.white, theme.palette.action.hoverOpacity)
                },
                width: DIAMETER,
                height: DIAMETER,
                color: 'currentColor'
            },
            open && {
                bgcolor: (theme)=>alpha(theme.palette.common.white, theme.palette.action.focusOpacity)
            }
        ],
        ...other
    }, children));
});
AppbarButton.displayName = 'AppbarButton';
AppbarButton.propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object
    ]),
    size: PropTypes.oneOf([
        'small',
        'medium',
        'large'
    ]),
    title: PropTypes.string
};
export default AppbarButton;
